import { Component, inject, OnInit } from '@angular/core';
import { AuthenticationService } from './service/authentication.service';
import { RouterModule } from '@angular/router';
import { SharedModule } from './module/shared.module';
import { ProgressSpinnerComponent } from './spinner/spinner.module';
import { ToastShowComponent } from './spinner/toast.module';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { Meta } from '@angular/platform-browser';
import { L10n } from '@syncfusion/ej2-base';

L10n.load({
  fr: {
    grid: {
      EmptyRecord: 'Aucun enregistrement affiché',
      Search: 'Rechercher'
    },
    pager: {
      currentPageInfo: '{0} de {1} pages',
      pagerDropDown: 'objets par page',
      pagerAllDropDown: 'objets',
      totalItemsInfo: '	({0} objets)',
      totalItemInfo: '	({0} objet)'
    },
    daterangepicker: {
      placeholder: 'Choisir une date',
      startLabel: 'Date de départ',
      endLabel: 'Date de fin',
      applyText: 'Appliquer',
      cancelText: 'Annuler',
      selectedDays: 'Jours sélectionnés',
      days: 'jours',
      customRange: 'date personnalisée'
    }
  },
  en: {
    grid: {
      EmptyRecord: 'No records displayed',
      Search: 'Search'
    },
    pager: {
      currentPageInfo: '{0} of {1} pages',
      pagerDropDown: 'items by page',
      pagerAllDropDown: 'items',
      totalItemsInfo: '	({0} items)',
      totalItemInfo: '	({0} item)'
    },
    daterangepicker: {
      placeholder: 'Select a date',
      startLabel: 'Start date',
      endLabel: 'End date',
      applyText: 'Apply',
      cancelText: 'Cancel',
      selectedDays: 'Selected days',
      days: 'days',
      customRange: 'custom range'
    }
  }
});

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [
    SharedModule,
    ProgressSpinnerComponent,
    ToastShowComponent,
    RouterModule
  ]
})
export class AppComponent implements OnInit {
  private authService = inject(AuthenticationService);
  public messenger = false;
  title = 'zipplex';
  constructor(
    private translate: TranslateService,
    private cookieService: CookieService,
    private metaTagService: Meta,
  ) {}

  ngOnInit() {
    if (this.cookieService.get('.AspNetCore.Culture')) {
      let lang = this.cookieService.get('.AspNetCore.Culture').substring(2, 4);
      if (lang !== 'en' && lang !== 'fr') lang = 'fr';
      this.translate.use(lang);
    } else {
      this.translate.addLangs(['fr', 'en']);
      this.translate.setDefaultLang('fr');
      this.translate.use('fr');
      this.cookieService.set('.AspNetCore.Culture', 'c=fr|uic=fr');
    }
    this.metaTagService.addTags([{ name: 'robots', content: 'noindex' }]);
    this.authService.initProactiveRefresh();
  }
}
